import React from 'react';
import { Link } from 'react-router-dom';
import { Leaf } from 'lucide-react';

const Footer = ({ scrollToSection }) => {
  return (
    <footer className="bg-[#3E8FA5] text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          {/* Logo and Branding */}
          <div className="flex items-center space-x-4">
            <Leaf className="w-12 h-12" strokeWidth={1.5} />
            <div>
              <h3 className="text-3xl font-serif tracking-wide">AYUMI SUZUKI</h3>
              <p className="text-sm tracking-widest text-white/80">certified massage therapist</p>
            </div>
          </div>

          {/* Navigation Links */}
          <div className="flex flex-col items-start md:items-end space-y-4">
            <div className="flex flex-wrap gap-6">
              <Link
                to="/about"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                About
              </Link>
              <Link
                to="/blog"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                Blog
              </Link>
              <Link
                to="/faq"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                FAQ
              </Link>
              <Link
                to="/massage-midtown-sacramento"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
                data-testid="footer-midtown-link"
              >
                Midtown Studio
              </Link>
              <Link
                to="/gift-certificates"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
                data-testid="footer-gift-link"
              >
                Gift Certificates
              </Link>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                Contact
              </button>
            </div>
            
            {/* Social Media Text Links */}
            <div className="flex flex-wrap gap-6">
              <a 
                href="https://www.facebook.com/profile.php?id=61580747109661"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                Facebook
              </a>
              <a 
                href="https://www.instagram.com/ayumimassage/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              >
                Instagram
              </a>
            </div>
            
            <a 
              href="mailto:ayumisuzuki@yahoo.com"
              className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
            >
              ayumisuzuki@yahoo.com
            </a>
            <Link
              to="/massage-midtown-sacramento"
              className="text-sm text-white/90 hover:text-white transition-colors duration-300 hover:underline underline-offset-4"
              data-testid="footer-address-link"
            >
              2528 I Street, Midtown Sacramento, CA 95816
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/70">
          <p>© {new Date().getFullYear()} Ayumi Suzuki. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;